import { render, staticRenderFns } from "./Backoffices.vue?vue&type=template&id=dcaded80"
import script from "./Backoffices.vue?vue&type=script&lang=js"
export * from "./Backoffices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports